// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"3781af5a","977":"a3ab07ec"}[chunkId] + ".chunk.js";
};